import { descending } from 'd3'
import { AutoAgGrid, generateString, setPageAsFullHeight } from '@local_modules/flokit'
import { fillString } from '@local_modules/generic/string-template.js'
import { numberFixDecimals } from '@local_modules/generic/numbers/number-fix-decimals/index.js'
import { setElementHtml } from '@local_modules/generic/dom/set-element-html.js'

import { applyHtmlRestrictions } from '../../../../helpers/restrictions/apply-html-restrictions.js'
import { checkPageRestriction } from '../../../../helpers/restrictions/check-page-restriction.js'

import htmlTemplateIndex from './index.html'
import { loadData } from './load-data.js'

export async function showPageAdminEntityNumbers (params) {
  const { containerElementId, browserAppUser, browserAppEntity, accountingOrganisationId } = params

  if (!checkPageRestriction({ browserAppUser, allowNoAccount: true })) return

  // Prepare the html
  let htmlIndex = htmlTemplateIndex

  htmlIndex = applyHtmlRestrictions(htmlIndex, { browserAppUser })
  const elementId = 'i' + generateString()
  htmlIndex = fillString(htmlIndex, {
    elementId,
    accountingOrganisationId,
    entityName: browserAppEntity?.data?.appEntity?.name
  })

  // Inject in the page
  setElementHtml(containerElementId, htmlIndex)

  setPageAsFullHeight(true, { containerSelector: '#app-content' })

  const data = await loadData(accountingOrganisationId)
  console.log('data', data)

  const preparedGridRows = prepareGridData(data)
  console.log('preparedGridRows', preparedGridRows)

  const gridContainerElementId = 'numbersGrid'
  const autoGrid = new AutoAgGrid({
    containerSelector: `#${gridContainerElementId}`,
    data: preparedGridRows,
    gridParams: {
      columns: {
        name: {
          pinned: 'left'
        }
      }
    }
  })
  console.log('autoGrid', autoGrid)
}

function prepareGridData (data) {
  console.log('prepareGridData', data)

  const rows = []

  const rowJournalsPositive = reduceToColumns(data.journalsValues?.monthlyValues?.filter(d => +d.sum > 0), 'month', 'sum')
  const rowJournalsNegative = reduceToColumns(data.journalsValues?.monthlyValues?.filter(d => +d.sum < 0), 'month', 'sum')
  const rowJournals = reduceToColumns(data.journalsValues?.monthlyValues, 'month', 'sum')
  rows.push({ name: 'Journals >0', ...rowJournalsPositive })
  rows.push({ name: 'Journals <0', ...rowJournalsNegative })
  rows.push({ name: 'Journals', ...rowJournals })

  const rowTrialBalancePositive = reduceToColumns(data.tbValues?.trialBalances?.filter(d => +d.amount > 0), 'date', 'amount')
  const rowTrialBalanceNegative = reduceToColumns(data.tbValues?.trialBalances?.filter(d => +d.amount < 0), 'date', 'amount')
  const rowTrialBalance = reduceToColumns(data.tbValues?.trialBalances, 'date', 'amount')
  rows.push({ name: 'Trial Balance >0', ...rowTrialBalancePositive })
  rows.push({ name: 'Trial Balance <0', ...rowTrialBalanceNegative })
  rows.push({ name: 'Trial Balance', ...rowTrialBalance })

  rows.push({ name: '=>> Journals - TBs', ...compareValues(rowJournalsPositive, rowTrialBalancePositive) })

  const rowAdjustmentsPositive = reduceToColumns(data.adjustments?.filter(d => +d.amount > 0), 'date', 'amount')
  const rowAdjustmentsNegative = reduceToColumns(data.adjustments?.filter(d => +d.amount < 0), 'date', 'amount')
  const rowAdjustments = reduceToColumns(data.adjustments, 'date', 'amount')
  rows.push({ name: 'Adjustments >0', ...rowAdjustmentsPositive })
  rows.push({ name: 'Adjustments <0', ...rowAdjustmentsNegative })
  rows.push({ name: 'Adjustments', ...rowAdjustments })

  const rowLedgersPositive = reduceToColumns(data.ledgersValues?.monthlyValues?.filter(d => +d.amount > 0), 'month', 'amount')
  const rowLedgersNegative = reduceToColumns(data.ledgersValues?.monthlyValues?.filter(d => +d.amount < 0), 'month', 'amount')
  const rowLedgers = reduceToColumns(data.ledgersValues?.monthlyValues, 'month', 'amount')
  rows.push({ name: 'Ledgers >0', ...rowLedgersPositive })
  rows.push({ name: 'Ledgers <0', ...rowLedgersNegative })
  rows.push({ name: 'Ledgers', ...rowLedgers })

  rows.push({ name: '=>> TBs - Ledgers', ...compareValues(rowTrialBalancePositive, rowLedgersPositive) })

  return rows
}

function compareValues (row1, row2) {
  const newRow = {}
  const keys = Object.keys(row1)
  for (const key of keys) {
    const value1 = row1[key]
    const value2 = row2[key]

    newRow[key] = value1 - value2
  }
  return newRow
}

function reduceToColumns (array, dateProperty, amountProperty) {
  array.sort((a, b) => descending(a[dateProperty], b[dateProperty]))

  const row = array?.reduce((acc, curr) => {
    const monthISO = curr[dateProperty]?.substring(0, 7)
    const amount = parseFloat(curr[amountProperty])
    acc[monthISO] = acc[monthISO] || 0
    acc[monthISO] += amount

    acc[monthISO] = numberFixDecimals(acc[monthISO], 2)
    return acc
  }, {})
  return row
}
